import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    autoRefreshToken: true,
    detectSessionInUrl: true,
    persistSession: true,
    storage: window.localStorage,
    // Custom email template configuration
    emailRedirectTo: `${window.location.origin}/auth/callback`,
    // Custom email template function
    emailAuth: {
      getCustomEmailTemplate: async ({ type, email, token }) => {
        try {
          const response = await fetch(`${supabaseUrl}/functions/v1/auth-emails`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${supabaseAnonKey}`,
            },
            body: JSON.stringify({ type, email, token }),
          });

          if (!response.ok) {
            throw new Error('Failed to fetch custom email template');
          }

          const template = await response.json();
          return template;
        } catch (error) {
          console.error('Error fetching custom email template:', error);
          return null;
        }
      },
    },
  },
});

// Helper function to get the current user
export const getCurrentUser = async () => {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
};